// extracted by mini-css-extract-plugin
export default {"culturePage":"culturePage-wN_vN","header":"header-hLd8o","tabs":"tabs-evH_0"};